import { USER_STATE } from './constants'
import { UserState } from './state'

export const getCreditCard = (state: UserState) => state[USER_STATE].creditCard
export const getIsFetching = (state: UserState) => state[USER_STATE].isFetching
export const getIsPasswordChanged = (state: UserState) => state[USER_STATE].isPasswordChanged
export const getIsUserCreated = (state: UserState) => state[USER_STATE].isUserCreated
